import { QuestionStructure } from "./question";
import { ModerationDashStructure } from "./moderation-dash";
import { ArticleStructure } from "./article";
import { VideoVotingStructure } from "open-modules/zdf/structure/videovoting";
import { TopicStructure } from "./topic";
import { ComponentDemoStructure } from "./componentdemo";
import { ProfileStructure } from "./profile";
import { SimpleCommentsStructure } from "./simple-comments";
import { MigrationsStructure } from "system/migrations";
import { LoginStructure } from "./login";
import { AdminStructure } from "./admin";
import { ModDashboardStructure } from "open-modules/zdf/structure/moddashboard";
import { AccountStructure } from "./account";
import { EditorialDashStructure } from "./editorial-dash";
import type { Structure } from "util/stdtypes";

export const structures : Structure<any>[] = [
    QuestionStructure,
    ModerationDashStructure,
    ArticleStructure,
    VideoVotingStructure,
    TopicStructure,
    SimpleCommentsStructure,
    ComponentDemoStructure,
    ProfileStructure,
    MigrationsStructure,
    LoginStructure,
    AdminStructure,
    AccountStructure,
    ModDashboardStructure,
    EditorialDashStructure
];

export const specialScreens = ['teaser', 'fragmentRedirect', 'overlayScreen', 'browserPermission'];
export const embeddableSidebarStructures = ['question', 'topic', 'article', 'simple-comments'];
